import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
//MUI
import { Checkbox, Grid, Stack, Box, FormControl, Select, MenuItem, Typography } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

import { theme } from '../../assets/themes';
import UButton from "../../components/mui/UButton";
import USelectBox from "../../components/mui/USelectBox";
import UAuthButton from "../../components/mui/UAuthButton";
import UBreadCrumbs from "../../components/mui/UBreadCrumbs";
import UAlertDialog from "../../components/mui/UAlertDialog";
import UPopupForm from "../../components/mui/UPopupForm";
import UTable from "../../components/mui/UTable";
import UTextField from "../../components/mui/UTextField";

import { API, } from "../../config";
import { fni18n } from "../../services/commonService";
import { getAPI,postAPI,putAPI, } from "../../services/commonService";
import BranchGroupModify from "./BranchGroupModify";
import AuthenticationService from "../auth/AuthenticationService.js";

const useYn = [
    {cd: "Y", name: "Y"},
    {cd: "N", name: "N"},
];
const GROUP_TY = [
    {cd: "BIZ_TY", name: "BIZ_TY"},
    {cd: "RGN_TY", name: "RGN_TY"},
];

export default function BranchGroupPage(){
    const isUserId = AuthenticationService.getLoggedInUserID();
	const { t } = useTranslation();
    const now = new Date().toISOString().slice(0, 10).replace(/-/g,"");
    const today = new Date();
    const hours = today.getHours() < 10 ? "0"+today.getHours() : today.getHours(); // 시
    const minutes = today.getMinutes() < 10 ? "0"+today.getMinutes() : today.getMinutes();  // 분
    const seconds = today.getSeconds() < 10 ? "0"+today.getSeconds() : today.getSeconds();  // 초
    const date = now+hours+minutes+seconds;
    const columns = [
        { 
            field: 'id',
            headerName: '번호',
            headerAlign: 'center',
            align: 'center',
            hide: true,
        },
        {
            field: 'branchGroupNm',
            headerName: '그룹명',
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'branchGroupTy',
            headerName: '그룹유형',
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'description',
            headerName: '설명',
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'useYn',
            headerName: '사용여부',
            align: "center",
            headerAlign: "center",
            valueFormatter: (params)=>{
                if(params.value=="Y"){
                    return <Checkbox checked={true} disabled style={{color: theme.palette.primary.main}} />
                }else {
                    return <Checkbox checked={false} disabled/>
                }
            }
        },
        {
            field: 'regDt',
            headerName: '등록일',
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'button',
            headerName: '설정',
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) =>
            (
                <UButton
                variant="outlined"
                onButtonClick={()=>handleRowSelect(params.rows)}
                menuFrom={location.pathname}
                >
                    보기
                </UButton>
            ),
        },
    ];
    const location = useLocation();
    const [branchs, setBranch] = useState([]);
    const [brands, setBrands] = useState([]);
    const [groups, setGroups] = useState([]);
    const [branchList, setBranchList] = useState([{}]);                 //지점
    const [errorPopupOpen, setErrorPopupOpen] = useState(false);        // error dialog
    const [errorMsg, setErrorMsg] = useState("");                       // api error message
    const [formOpen, setFormOpen] = useState(false);
    const [modify, setModify] = useState({
        branchCd : "",          //지점코드
        branchNm:"",            //지점명
        regId:isUserId,               //등록자
        regDt:date,               //등록일
        chkCreate : false,      //add, modify 여부
        useYn : "Y",           //사용여부
    });
    const [search, setSearch] = useState({
        useYn: "Y",
    });

    //화면 로드 시
    useEffect(() => {
        const getLoadData = async () => {
            try {
                await getList();
            } catch (e) {
                console.log(e)
            }
        };
        getLoadData();
    }, []);

    const getList = async() => {
        try{
            await getAPI(API.SYSTEM.BRANCH_GROUP, search).then((res) => {
                if (res.data.code === 200) {
                    setBranchList(res.data.result);
                } else {
                    setErrorMsg(t("처리가 실패하였습니다"));
                    handleErrorOpen();
                }
            });
        }catch(e){
            console.log(e.message);
        }
    };
    
    const handleErrorOpen = () => {
        setErrorPopupOpen(true);
    };
    const handleErrorClose = () => {
        setErrorPopupOpen(false);
    };

    const handleFormOpen = () => {
        setFormOpen(true);
    };
    const handleFormClose = () => {
        setFormOpen(false);
        getList();

    };

    //Modify Btn click
    const handleRowSelect = (row) => {        
        handleFormOpen();   //상세팝업
    }

    //Table row Selected handler
    const onSelectedRows = (e, row) => {
        setModify({
            branchGroupId: row.id,
            branchGroupNm: row.branchGroupNm,
            branchGroupTy: row.branchGroupTy,
            description: row.description,
            useYn: row.useYn,
            regDt: row.regDt,
            chkCreate: row.branchGroupId?true:false,
        });
    };

    //value 속성으로만 값을 컨트롤 할 수 있어서 
    //onChange를 써서 element를 수정할 수 있는 상태로 만듦
    const onModifyChange = (e) => {
        const { name, value } = e.target;
        setModify({
            ...modify,
            [name]: value,
        });
    };
    const onCheckboxChange = (e) => {
        setModify({
          ...modify,
          [e.target.name]: e.target.checked === true ? "Y" : "N",
        });
    };

    
    const onButtonClick = async(dvsn)=>{
        if(dvsn === "추가"){
            setModify({
                useYn: "Y",
                regDt: date,
                chkCreate: true,
            });
            handleRowSelect({});
        } else if(dvsn === "조회"){
            await getAPI(API.SYSTEM.BRANCH_GROUP, search).then((res) => {
                if (res.data.code === 200) {
                    setBranchList(res.data.result);
                } else {
                    setErrorMsg(t("처리가 실패하였습니다"));
                    handleErrorOpen();
                }
            });
        }
    };

    const onSave = async (e) => { 
        let result;
         if (modify.chkCreate) {
             await postAPI(API.SYSTEM.BRANCH_GROUP, modify).then((res) =>{
                 result=res.data;
             });
        }else {
             await putAPI(API.SYSTEM.BRANCH_GROUP, modify).then((res) =>{
                 result=res.data;
             });
         }
        if (result.code==200){
            handleFormClose()
        } else {
            setErrorMsg(t("입력값이 잘못되었습니다."))
            handleErrorOpen()
        }
    }
    //검색조건 값 변경되었을 때
    const onSearchChange = async (e) => {
        const {name, value} = e.target;
        setSearch({
            ...search,
            [name]: value,
        });
    };

    return(
    <div className="main-container">
        <div className="header">
            <Grid container>
                <Grid item xs={10}>
                    {/* 상단메뉴명 */}
                    <UBreadCrumbs
                        title={"시스템관리"}
                        subtitle={"지점그룹관리"}
                    />
                </Grid>
                <Grid item xs={2}>
                    {/* 툴바 버튼 */}
                    <Stack
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="flex-start"
                        spacing={0.5}
                    >
                    </Stack>
                </Grid>
            </Grid>
            {/* <Divider variant="middle"/> */}
        </div>

        <div className="contents">      
            <Box>
                {/* 조회조건 */}
                <TableContainer className="table-container">
                    <Table className="table" size="small">
                        <TableBody>
                            <TableRow className="table-row-header">
                                <TableCell className="table-cell-title">{fni18n("그룹명")}</TableCell>
                                <TableCell className="table-cell">
                                    <UTextField name="groupNm" onChange={onSearchChange}/>
                                </TableCell>
                                <TableCell className="table-cell-title">{fni18n("그룹유형")}</TableCell>
                                <TableCell className="table-cell">
                                    <FormControl size="small" fullWidth={true}>
                                    <Select
                                        name="branchGroupTy"
                                        value={search.branchGroupTy}
                                        onChange={onSearchChange}
                                        >
                                        {GROUP_TY.map((map)=>(
                                            <MenuItem key={map.name} value={map.name}>
                                                {map.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    </FormControl>
                                </TableCell>
                                <TableCell className="table-cell-title">{fni18n("사용여부")}</TableCell>
                                <TableCell className="table-cell">
                                    <USelectBox
                                        id="useYn"
                                        name="useYn"
                                        items={useYn}
                                        onItemChange={onSearchChange}
                                        defaultValue={search.useYn}
                                    />
                                </TableCell>
                                <TableCell className="table-cell"></TableCell>
                                <TableCell className="table-cell"></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                <div className="search">
                    <UButton icon="Search" onButtonClick={onButtonClick}>
                        조회
                    </UButton>
                </div>
            </Box>
            {/* 조회 리스트 */}
            <UTable 
                columns={columns} 
                rows={branchList}
                onSelectedRowChange={onSelectedRows}
                rowPerPage={10}
                toolbarAdd={
                    <>
                    <UAuthButton 
                        icon="Add" 
                        menuFrom={location.pathname} 
                        onButtonClick={onButtonClick}
                    >
                        추가
                    </UAuthButton>
                    </>
                }
            />
        </div>
        {/* Alert */} 
        <UAlertDialog
            message={errorMsg}
            open={errorPopupOpen}
            onClose={handleErrorClose}
        />
        {/* Dialog */}
        <UPopupForm
            open={formOpen}
            onClose={handleFormClose}
            onSave={onSave}
            title='설정'
            type={"2"}
            content={<BranchGroupModify data={modify} onParamsChange={onModifyChange} onCheckboxChange={onCheckboxChange} />}
        /> 
    </div>
    );
}